<div
  data-cy="guided-tour.dialog"
  #dialog
  class="step-container">
  <div class="step">
    <div class="step__header">
      <span
        data-cy="guided-tour-step.step-number"
      >{{ 'guidedTour.stepPagination' | translate:{
        currentStepNumber: step.dialog.stepNumber,
        numberOfSteps: step.dialog.stepCount
      } }}</span>
      <span
        (click)="exitDemo()"
        *ngIf="!step.dialog.hideExitDemo"
        class="step__header-exit-demo"
      >{{ 'page.planner.guidedTour.action.exitDemo' | translate }}</span>
    </div>

    <div class="step-contents">
      <div
        *ngIf="step.dialog.description"
        class="step-contents__description"
      >{{ step.dialog.description | translate }}</div>

      <div
        *ngIf="step.dialog.nextStepDescription"
        class="step-contents__next-step-description"
      >{{ step.dialog.nextStepDescription | translate }}</div>

      <div>
        <button
          data-cy="guided-tour.dialog-next-button"
          (click)="onNextClick()"
          *ngIf="step.dialog.displayNextStepButton"
          class="media-button media-button--secondary step-contents__actions"
        >{{ 'page.planner.guidedTour.action.next' | translate }}</button>
        <button
          data-cy="guided-tour.dialog-exit-demo-button"
          (click)="exitDemo()"
          *ngIf="step.dialog.displayExitCampaignButton"
          class="media-button media-button--secondary step-contents__actions"
        >{{ 'page.planner.guidedTour.action.exitDemo' | translate }}</button>
      </div>
    </div>

  </div>
</div>
